export const listTitle = 'Mis Tarjetas';

export const ticket = (
  repetitions: number,
  prize: string,
) => `¡Junta ${repetitions} marcas por ${prize}!`;
export const checksProgress = (checks: number, repetitions: number) => `${checks}/${repetitions}`;
